// Thin os-core wrapper around the @os/notes web page, mirroring
// KnowledgeWorkspacePage. Routed from App.tsx at /workspace/notes.
import NotesPage from '@os/notes/web/pages/NotesPage'

export default function NotesWorkspacePage() {
  return <NotesPage />
}
